module.exports = __webpack_public_path__ + "img/slideshow-carnets-03-couverture.b1c6f8a9.png";